<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            class="gst-svg-icon gst-svg-icon--stroke"
            d="M6.062 14.667V13v1.667Zm2.296 0v-3.334 3.334Zm2.296 0v-5 5ZM12.185 18H4.531a1.47 1.47 0 0 1-1.083-.488A1.744 1.744 0 0 1 3 16.333V4.667c0-.442.161-.866.448-1.179A1.47 1.47 0 0 1 4.531 3h4.276c.203 0 .397.088.54.244l4.145 4.512a.873.873 0 0 1 .224.589v7.988c0 .442-.161.866-.448 1.179a1.47 1.47 0 0 1-1.083.488Z"
            stroke="#333"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"></path>
        <mask
            id="a"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="14"
            y="14"
            width="9"
            height="7">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.8 17.048c.772 0 1.4-.683 1.4-1.524 0-.84-.628-1.524-1.4-1.524-.772 0-1.4.684-1.4 1.524s.628 1.524 1.4 1.524ZM14 19.335c0-1.015 1.864-1.524 2.8-1.524.936 0 2.8.51 2.8 1.524v.762H14v-.762Zm2.8-.654c-.716 0-1.528.292-1.864.545h3.728c-.336-.253-1.148-.544-1.864-.544Zm.6-3.157c0-.361-.268-.653-.6-.653-.332 0-.6.292-.6.653 0 .362.268.653.6.653.332 0 .6-.291.6-.653Zm2.216 2.313c.464.366.784.853.784 1.498v.762H22v-.762c0-.88-1.4-1.38-2.384-1.498Zm.984-2.313c0 .84-.628 1.524-1.4 1.524-.216 0-.416-.056-.6-.152.252-.388.4-.862.4-1.372 0-.51-.148-.984-.4-1.372.184-.095.384-.152.6-.152.772 0 1.4.684 1.4 1.524Z"
                fill="#fff"></path>
        </mask>
        <g mask="url(#a)">
            <path
                class="gst-svg-icon gst-svg-icon--fill"
                fill="#333"
                d="M12.974 11.564h10.075v10.969H12.974z"></path>
        </g>
    </svg>
</template>
<script>
export default {
    name: 'IconCustomerReports',
};
</script>
